import GoogleMapsLoader from "google-maps";
import { section } from "@/neon";
import { animateLocation } from "@/lib/animation";

const selectors = {
  mapContainer: ".location__map-container",
  mapElement: ".location__map-element",
};

const fullMapURL = "https://www.google.com/maps/place/";

section("location", {
  onLoad() {
    this._initMap();
  },

  _initMap() {
    this.animateLocation = animateLocation(this.container);
    this.mapContainer = this.container.querySelector(selectors.mapContainer);
    let address = null;
    let apiKey = null;

    if (this.mapContainer) {
      address = this.mapContainer.dataset.address;
      apiKey = this.mapContainer.dataset.apiKey;
    }

    if (!apiKey || !address) {
      return;
    }

    const { sectionId } = this.container.dataset;
    const styledData = document.querySelector(`#map-styles-${sectionId}`);
    const data = JSON.parse(styledData.innerHTML);

    GoogleMapsLoader.KEY = apiKey;
    GoogleMapsLoader.VERSION = "3.34";
    GoogleMapsLoader.LIBRARIES = ["geocoding-api"];

    GoogleMapsLoader.load(google => {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address }, (res, status) => {
        if (res.length === 0) {
          return console.error(
            `Google Maps Geocoding failed, reason: ${status}`
          );
        }

        const { location } = res[0].geometry;
        const latLong = { lat: location.lat(), lng: location.lng() };
        this.mapContainer.classList.add("active");

        const map = new google.maps.Map(
          this.container.querySelector(selectors.mapElement),
          {
            center: latLong,
            zoom: 12,
            styles: data.styles,
          }
        );

        const marker = new google.maps.Marker({
          position: latLong,
          map,
        });

        marker.addListener("click", () => {
          window.open(fullMapURL + address);
        });
      });
    });
  },

  onUnload() {
    GoogleMapsLoader.release();
    this.animateLocation?.destroy();
  },
});
